export interface ErkomListItem {
  id: number;
  clinical_status: string;
  comertial_status: string;
  remainingDaysSurgery: number;
  surgery: string | null;
  patient: string;
  id_number: string | number;
  medic: string;
  surgery_location: string;
  healthInsurance: string;
  procedure: string;
  implantsNumber: string | number;
  material: string;
  cryoanalgesia: string;
  showFirstButton?: boolean;
  isDisabled?: boolean;
}